// Yes/no questions are stored as 'yes' | 'no' | null (null = not answered yet).
// The strings are part of the persisted and imported data shape, so they stay
// strings; compare through these helpers instead of repeating the literals.
export const YES = 'yes'
export const NO = 'no'

/** @param {unknown} answer */
export const isYes = answer => answer === YES

/** @param {unknown} answer */
export const isNo = answer => answer === NO
